export default {"src":"/_next/static/media/PDF.30126f0c.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};